var stringReg = /"(?:[^\\"]|\\(?:[bfnrtv"\\/]|u[0-9a-fA-F]{4}))*"/;
var numberReg = /-?(0|[1-9]\d*)(\.\d+)?([eE][+-]?\d+)?/;
var trueReg = /true/;
var falseReg = /false/;
var parse = function parse(str) {
  var _str$match;
  if (((_str$match = str.match(numberReg)) === null || _str$match === void 0 ? void 0 : _str$match[0]) === str) {
    return Number(str);
  }
  if (trueReg.test(str)) {
    return true;
  }
  if (falseReg.test(str)) {
    return false;
  }
  if (stringReg.test(str)) {
    return str;
  }
  return str;
};
export default function getSearchParams() {
  var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.search;
  var searchParams = new URLSearchParams(search);
  var temp = {};
  searchParams.forEach(function (value, key) {
    var pV = parse(value);
    if (temp[key]) {
      if (temp[key] instanceof Array) {
        temp[key].push(pV);
      } else {
        temp[key] = [temp[key], pV];
      }
    } else {
      temp[key] = pV;
    }
  });
  return temp;
}